// Import model
import { OtgCatalogManufacturer } from '../models/OtgCatalogManufacturer';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgCatalogManufacturer - handles JSON serialization and deserialization with type validation
 */
export class OtgCatalogManufacturerSerializer {
  /**
   * Deserializes a JSON string into a OtgCatalogManufacturer instance
   */
  static deserialize(json: string): OtgCatalogManufacturer {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgCatalogManufacturer instance
   */
  static fromObject(obj: any): OtgCatalogManufacturer {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgCatalogManufacturer');
    }


    const instance: OtgCatalogManufacturer = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      count: obj['Count'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgCatalogManufacturer instances
   */
  static deserializeArray(json: string): OtgCatalogManufacturer[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgCatalogManufacturer instance to a JSON string
   */
  static serialize(instance: OtgCatalogManufacturer): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgCatalogManufacturer instance to a plain object
   */
  static toObject(instance: OtgCatalogManufacturer): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'Count': instance.count,
    };
  }

  /**
   * Serializes an array of OtgCatalogManufacturer instances to a JSON string
   */
  static serializeArray(instances: OtgCatalogManufacturer[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
